import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgList = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 14a.875.875 0 0 1-.875.875H4.375a.875.875 0 0 1 0-1.75h19.25A.875.875 0 0 1 24.5 14ZM4.375 7.875h19.25a.875.875 0 1 0 0-1.75H4.375a.875.875 0 0 0 0 1.75Zm19.25 12.25H4.375a.875.875 0 0 0 0 1.75h19.25a.875.875 0 1 0 0-1.75Z" />
  </svg>
);
export default SvgList;
